import dayjs from 'dayjs';
import _groupBy from 'lodash/groupBy';
import { mapActions, mapState } from 'vuex';

import { OrderCard } from '@/components';
import { GROUP_BUYING_STATUS, ORDERS_TABS } from '@/utils/constants';
import { getWeekString } from '@/utils/helper';

export default {
  name: 'Orders',
  components: {
    OrderCard,
  },
  data() {
    return {
      activeTab: ORDERS_TABS.THIS_MONTH,
      page: 1,
      tabs: ['本月', '上月'],
    };
  },
  computed: {
    ...mapState('order', {
      gettingOrders: ({ gettingOrders }) => gettingOrders,
      orderInfos: ({ orders }) => orders,
    }),
    infos() {
      return [
        {
          class: 'font-medium',
          label: '本月累計金額',
          price: this.orderTotal,
        },
        {
          label: '補助金額',
          price: this.subsidyTotal,
        },
        {
          label: '自付額',
          price: this.outOfSubsidyTotal,
        },
      ];
    },
    inLoading() {
      return this.gettingOrders;
    },
    lastPage() {
      return this.orderInfos?.pagination?.total_page || 1;
    },
    noMorePages() {
      return this.page >= this.lastPage;
    },
    orders() {
      return this.orderInfos?.group_buyings || [];
    },
    orderCount() {
      return this.orderInfos?.order_count || 0;
    },
    orderGroups() {
      const results = {};
      const groups = _groupBy(this.orders, ({ receive_times: receiveTimes = [] }) => dayjs(receiveTimes[0]?.start_time || '').format('YYYY-MM-DD'));
      Object.keys(groups).sort((a, b) => new Date(b) - new Date(a)).forEach((groupKey) => {
        results[groupKey] = groups[groupKey]
          .sort(
            (a, b) => new Date(
              a.receive_times[0]?.start_time,
            ) - new Date(
              b.receive_times[0]?.start_time,
            ),
          );
      });
      return results;
    },
    orderTotal() {
      return this.orderInfos?.order_total || 0;
    },
    outOfSubsidyTotal() {
      return this.orderInfos?.out_of_subsidy_total || 0;
    },
    subsidyTotal() {
      return this.orderInfos?.subsidy_total || 0;
    },
    targetDate() {
      const targetMonth = dayjs().month() - this.activeTab;
      return {
        end_date: dayjs().set('M', targetMonth).endOf('M').format('YYYY-MM-DD'),
        start_date: dayjs().set('M', targetMonth).startOf('M').format('YYYY-MM-DD'),
      };
    },
  },
  watch: {
    async activeTab(newVal, oldVal) {
      if (Number.isInteger(newVal) && newVal !== oldVal) {
        await this.getOrders(this.targetDate);
      }
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  async created() {
    await this.getOrders(this.targetDate);
  },
  methods: {
    ...mapActions('order', {
      getOrders: 'GET_ORDERS',
    }),
    isOrderCanceled(order) {
      return order.status === GROUP_BUYING_STATUS.CANCELED;
    },
    receiveData(receiveTime = '') {
      return receiveTime ? dayjs(receiveTime).format('MM/DD') : '';
    },
    receiveWeek(receiveTime = '') {
      return receiveTime ? getWeekString(receiveTime) : '';
    },
  },
};
